/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStandardBerechtigungenDto } from '../../models/lexplus-standard-berechtigungen-dto';
import { LexplusUpdateStandardBerechtigungenDto } from '../../models/lexplus-update-standard-berechtigungen-dto';

export interface StandardBerechtigungenControllerUpdateV1$Params {
      body: LexplusUpdateStandardBerechtigungenDto
}

export function standardBerechtigungenControllerUpdateV1(http: HttpClient, rootUrl: string, params: StandardBerechtigungenControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusStandardBerechtigungenDto>> {
  const rb = new RequestBuilder(rootUrl, standardBerechtigungenControllerUpdateV1.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusStandardBerechtigungenDto>;
    })
  );
}

standardBerechtigungenControllerUpdateV1.PATH = '/v1/benutzerverwaltung/standard-berechtigungen';
